import firebase from '@firebase/app';
import '@firebase/messaging';

const config = {
  apiKey: 'AIzaSyDxDqjHu6xp0GFzGD0xiCG3bSCEiCzSc8Q',
  authDomain: 'rastech-hospitech.firebaseapp.com',
  projectId: 'rastech-hospitech',
  storageBucket: 'rastech-hospitech.appspot.com',
  messagingSenderId: '1008082037838',
  appId: '1:1008082037838:web:75e48183b801d89d9be71f',
  measurementId: 'G-9RF22RP866',
};

firebase.initializeApp(config);

const initFirebase = (
  thisUser,
  submitSingleDevice,
  requireConversation,
  requireNewMessages
) => {
  addBackgroundUpdate(requireConversation, requireNewMessages);
  if (
    firebase.messaging.isSupported() &&
    Notification.permission !== 'denied'
  ) {
    const messaging = firebase.messaging();
    if (!thisUser.firebaseToken) {
      messaging.requestPermission().then(() => {
        messaging.getToken().then((token) => {
          messaging.usePublicVapidKey(
            'BDqjcGlyictH0JtRB33G0vz_xzWqE4brA1IRlEo0mwRBoB19vfMJETMiUfqkWP-_oBKCHtD6i_KYUQQ7ruw0ugU'
          );
          registerFirebaseToken(submitSingleDevice, token);
        });
      });
    }
    messaging.onMessage(async (payload) => {
      let sent = false;
      // update conversations
      requireConversation(+payload.data.conversationId);
      requireNewMessages(+payload.data.conversationId, +payload.data.messageId);
      // send notification
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        registrations.forEach(function (registration) {
          if (
            sent === true ||
            document.hidden ||
            !payload._notification ||
            !registration.scope.includes('firebase-cloud-messaging-push-scope')
          )
            return;
          sent = true;

          const topic = payload.data.topic;
          if (topic === 'reminder') {
            const path = `/t/${
              payload.data.companyId || payload.data.company
            }/project/${
              payload.data.projectId
            }/task/editor/${payload.data.taskId}/info`;
            const title = payload._notification.title;
            const options = {
              body: payload._notification.body,
              icon: '/assets/reminder.png',
              data: {
                url: path,
              },
            };
            registration.showNotification(title, options);
          } else {
            const conversationId = payload.data.conversationId * 1;
            const content = JSON.parse(payload.data.content);
            const senderId = payload.data.senderId;
            if (senderId !== thisUser.userId) {
              const message = content.text;
              const taskId = content.taskId;
              const projectId = content.projectId;
              const companyId = content.companyId;
              const title = content.title || payload.data.senderName;
              requireConversation(conversationId);
              requireNewMessages(conversationId, payload.data.id);
              let path = '';
              let icon = '';
              if (topic.includes('inbox')) {
                path = `/t/${companyId}/project/${projectId}/task/editor/${taskId}/info`;
                icon = '/task.png';
              } else if (topic === 'direct') {
                path = '/';
                icon = '/chat.png';
              }
              const options = {
                body: message,
                icon: icon,
                data: {
                  url: path,
                },
              };
              if (message) {
                registration.showNotification(title, options);
              }
            }
          }
        });
      });
    });

    messaging.onTokenRefresh(() => {
      messaging.getToken().then((refreshedToken) => {
        registerFirebaseToken(submitSingleDevice, refreshedToken);
      });
    });
  }
};

function addBackgroundUpdate(requireConversation, requireNewMessages) {
  navigator.serviceWorker &&
    navigator.serviceWorker.addEventListener('message', (event) => {
      // console.log(`The service worker sent me a message: ${event.data}`);
      if (event.data.type === 'updateConversation') {
        requireConversation(+event.data.conversationId);
        requireNewMessages(+event.data.conversationId, +event.data.messageId);
      }
    });
}

const registerFirebaseToken = (submitSingleDevice, token) => {
  const name = navigator.userAgent;
  submitSingleDevice(name, token);
};

export default initFirebase;
